import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fa from './locales/fa.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fa: { translation: fa },
      en: { translation: en },
    },
    fallbackLng: 'fa',
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    detection: {
      // Check localStorage first (matching existing LanguageContext key),
      // then browser navigator language
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lavvissa_language',
      caches: ['localStorage'],
    },
    // Default namespace
    defaultNS: 'translation',
    // Do not wait for translations to load (they are bundled)
    react: {
      useSuspense: false,
    },
  });

export default i18n;
